<template>
  <div class="futures-positions">
    <!-- Tabs -->
    <div class="tabs">
      <button
        v-for="tab in tabs"
        :key="tab"
        :class="['tab-btn', { active: currentTab === tab }]"
        @click="currentTab = tab"
      >
        {{ tab }}
      </button>
    </div>

 <!-- ✅ Active Positions -->
<div v-if="currentTab === 'Active'" class="table-container">
  <!-- Desktop -->
  <table class="positions-table desktop-only">
    <thead>
      <tr>
        <th> {{ $t('turbo.Position') }}</th>
        <th> {{ $t('turbo.Amount') }}</th>
        <th> {{ $t('turbo.Entry') }}</th>
        <th> {{ $t('turbo.Liquidation') }}</th>
        <th> {{ $t('turbo.PnL / ROI') }}</th>
        <th> {{ $t('turbo.Actions') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="bet in activeBets" :key="bet._id" class="trade-row">
        <!-- Position -->
        <td>
          <div class="position-box" :class="bet.direction.toLowerCase()">
            <img :src="coinIcon(bet.symbol)" class="coin-icon" />
            <img v-if="bet.direction === 'LONG'" src="@/assets/img/trade/up.svg" class="side-icon" />
            <img v-else src="@/assets/img/trade/down.svg" class="side-icon" />
          </div>
        </td>
        <!-- Amount + Leverage -->
        <td>
          <div class="amount-box">
            <div class="amount-value">{{ getFiatSymbol(bet) }}{{ formatCurrency(bet.amount) }}</div>
            <div class="leverage-value">{{ bet.leverage }}x</div>
          </div>
        </td>
        <td>{{ formatPrice(bet.entryPrice, bet.symbol) }}</td>
        <td>{{ formatPrice(bet.liqPrice) }}</td>
        <td>
          <div class="pnl-combined" :class="bet.livePnl >= 0 ? 'win' : 'lose'">
            <div class="pnl-value">{{ getFiatSymbol(bet) }}{{ formatCurrency(bet.livePnl) }}</div>
            <div class="roi-value">{{ formatPercentage(bet.liveRoi) }}</div>
          </div>
        </td>
        <td>
          <button class="btn-close" @click="closeBet(bet)"> {{ $t('turbo.Close') }}</button>
         
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Mobile -->
 
<div class="mobile-only">
  <div class="mobile-header active">
    <span> {{ $t('turbo.Position') }}</span>
    <span> {{ $t('turbo.Wager') }}</span>
    <span style="margin-left: -25px;"> {{ $t('turbo.PnL / ROI') }}</span>
 
  </div>
  <div v-for="bet in activeBets" :key="bet._id" class="trade-card" >
    <!-- Satır 1 -->
    <div class="trade-header">
      <!-- Position -->
      <div class="position-box" :class="bet.direction.toLowerCase()">
        <img :src="coinIcon(bet.symbol)" class="coin-icon" />
        <img v-if="bet.direction === 'LONG'" src="@/assets/img/trade/up.svg" class="side-icon" />
        <img v-else src="@/assets/img/trade/down.svg" class="side-icon" />
      </div>
      <!-- Amount + Leverage -->
      <div class="amount-box">
        <div class="amount-value">{{ getFiatSymbol(bet) }}{{ formatCurrency(bet.amount) }}</div>
        <div class="leverage-value">{{ bet.leverage }}x</div>
      </div>
      <!-- PnL / ROI -->
      <div class="pnl-combined" :class="bet.livePnl >= 0 ? 'win' : 'lose'">
        <div class="pnl-value">{{ getFiatSymbol(bet) }}{{ formatCurrency(bet.livePnl) }}</div>
        <div class="roi-value">{{ formatPercentage(bet.liveRoi) }}</div>
      </div>
      <!-- Actions -->
      <div class="info-btn" @click="closeBet(bet)">✖</div>
    </div>

    <!-- Satır 2 -->
    <div class="trade-footer">
      <div class="entry">  {{ $t('turbo.Entry') }}: {{ formatPrice(bet.entryPrice, bet.symbol) }}</div>
      <div class="liq">  {{ $t('turbo.Liq') }}: {{ formatPrice(bet.liqPrice) }}</div>
    </div>
  </div>
</div>

</div>


<!-- ✅ Closed Positions -->
<div v-if="currentTab === 'Closed'" class="table-container">
  <!-- Desktop -->
  <table class="positions-table desktop-only">
    <thead>
      <tr>
        <th> {{ $t('turbo.Position') }}</th>
        <th> {{ $t('turbo.Amount') }}</th>
        <th> {{ $t('turbo.Entry') }}</th>
        <th> {{ $t('turbo.Exit') }}</th>
        <th> {{ $t('turbo.PnL / ROI') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="bet in closedBets" :key="bet._id" class="trade-row">
        <!-- Position -->
        <td>
          <div class="position-box" :class="bet.direction.toLowerCase()">
            <img :src="coinIcon(bet.symbol)" class="coin-icon" />
            <img v-if="bet.direction === 'LONG'" src="@/assets/img/trade/up.svg" class="side-icon" />
            <img v-else src="@/assets/img/trade/down.svg" class="side-icon" />
          </div>
        </td>

        <!-- Amount + Leverage -->
        <td>
          <div class="amount-box">
            <div class="amount-value">
              {{ getFiatSymbol(bet) }}{{ formatCurrency(bet.amount) }}
            </div>
            <div class="leverage-value">{{ bet.leverage }}x</div>
          </div>
        </td>

        <!-- Entry -->
        <td>{{ formatPrice(bet.entryPrice) }}</td>

        <!-- Exit -->
        <td>{{ formatPrice(bet.exitPrice) }}</td>

        <!-- PnL / ROI -->
        <td>
          <div class="pnl-combined" :class="bet.pnl >= 0 ? 'win' : 'lose'">
            <div class="pnl-value">
              {{ getFiatSymbol(bet) }}{{ formatCurrency(bet.pnl) }}
            </div>
            <div class="roi-value">{{ formatPercentage(bet.roi) }}</div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- ✅ Desktop Pagination -->
  <div class="pagination desktop-only">
    <button :disabled="closedPage === 1" @click="closedPage--"> {{ $t('turbo.Prev') }}</button>
    <span> {{ $t('turbo.Page') }} {{ closedPage }} / {{ closedTotalPages }}</span>
    <button :disabled="closedPage === closedTotalPages" @click="closedPage++"> {{ $t('turbo.Next') }}</button>
  </div>

  <!-- Mobile -->
  <div class="mobile-only">
    <!-- Header -->
    <div class="mobile-header closed">
      <span> {{ $t('turbo.Position') }}</span>
      <span> {{ $t('turbo.Wager') }}</span>
      <span style="margin-left: -25px;"> {{ $t('turbo.PnL / ROI') }}</span>
    </div>

    <!-- Rows -->
    <div v-for="bet in closedBets" :key="bet._id" class="trade-card">
      <!-- Satır 1 -->
      <div class="trade-header closed">
        <!-- Position -->
        <div class="position-box" :class="bet.direction.toLowerCase()">
          <img :src="coinIcon(bet.symbol)" class="coin-icon" />
          <img v-if="bet.direction === 'LONG'" src="@/assets/img/trade/up.svg" class="side-icon" />
          <img v-else src="@/assets/img/trade/down.svg" class="side-icon" />
        </div>

        <!-- Amount + Leverage -->
        <div class="amount-box">
          <div class="amount-value">
            {{ getFiatSymbol(bet) }}{{ formatCurrency(bet.amount) }}
          </div>
          <div class="leverage-value">{{ bet.leverage }}x</div>
        </div>

        <!-- PnL / ROI -->
        <div class="pnl-combined" :class="bet.pnl >= 0 ? 'win' : 'lose'">
          <div class="pnl-value">
            {{ getFiatSymbol(bet) }}{{ formatCurrency(bet.pnl) }}
          </div>
          <div class="roi-value">{{ formatPercentage(bet.roi) }}</div>
        </div>

        <!-- Info -->
        <div class="info-btn" @click="openDetails(bet)">ℹ️</div>
      </div>

      <!-- Satır 2 -->
      <div class="trade-footer">
        <div class="entry">
          {{ $t('turbo.Entry') }}: {{ formatPrice(bet.entryPrice, bet.symbol) }}
        </div>
        <div class="exit">
          {{ $t('turbo.Exit') }}: {{ formatPrice(bet.exitPrice, bet.symbol) }}
        </div>
      </div>
    </div>

    <!-- ✅ Mobile Pagination -->
    <div class="pagination mobile-only">
      <button :disabled="closedPage === 1" @click="closedPage--"> {{ $t('turbo. ') }}</button>
      <span> {{ $t('turbo.Page') }} {{ closedPage }} / {{ closedTotalPages }}</span>
      <button :disabled="closedPage === closedTotalPages" @click="closedPage++"> {{ $t('turbo.Next') }}</button>
    </div>
  </div>
</div>





   <!-- ✅ Public Positions -->
<div v-if="currentTab === 'Public'" class="table-container">
  <!-- Desktop -->
  <table class="positions-table desktop-only">
    <thead>
      <tr>
        <th> {{ $t('turbo.Trader') }}</th>
        <th> {{ $t('turbo.Position') }}</th>
        <th> {{ $t('turbo.Amount') }}</th>
        <th> {{ $t('turbo.Entry') }}</th>
        <th> {{ $t('turbo.Exit') }}</th>
        <th> {{ $t('turbo.PnL / ROI') }}</th>
    
      </tr>
    </thead>
    <tbody>
      <tr v-for="bet in publicBetsWithRoi" :key="bet._id" class="trade-row">
        <!-- Trader -->
       <td class="user-cell">
  <div class="user-info">
    <!-- Avatar -->
    <img
      v-if="bet.user?.avatar"
      :src="bet.user.avatar.startsWith('http') ? bet.user.avatar : process.env.VUE_APP_BACKEND_URL + bet.user.avatar"
      class="avatar-image"
    />

    <!-- Username -->
    <span class="username">{{ bet.user?.username || "Anon" }}</span>

   
  </div>
</td>

        <!-- Position -->
        <td>
          <div class="position-box" :class="bet.direction.toLowerCase()">
            <img :src="coinIcon(bet.symbol)" class="coin-icon" />
            <img v-if="bet.direction === 'LONG'" src="@/assets/img/trade/up.svg" class="side-icon" />
            <img v-else src="@/assets/img/trade/down.svg" class="side-icon" />
          </div>
        </td>
        <!-- Amount + Leverage -->
        <td>
          <div class="amount-box">
            <div class="amount-value">{{ getFiatSymbol(bet) }}{{ formatCurrency(bet.amount) }}</div>
            <div class="leverage-value">{{ bet.leverage }}x</div>
          </div>
        </td>
        <td>{{ formatPrice(bet.entryPrice, bet.symbol) }}</td>
        <td>{{ formatPrice(bet.exitPrice, bet.symbol) }}</td>
        <td>
          <div class="pnl-combined" :class="bet.pnl >= 0 ? 'win' : 'lose'">
            <div class="pnl-value">{{ getFiatSymbol(bet) }}{{ formatCurrency(bet.pnl) }}</div>
             <div class="roi-value">{{ formatPercentage(bet.roi) }}</div>
          </div>
        </td>
        
      </tr>
    </tbody>
  </table>

  <!-- Mobile -->
 <div class="mobile-only">
<div class="mobile-header public">
  <span>Trader</span>
  <span style="margin-left: -25px;"> {{ $t('turbo.Position') }}</span>
  <span style="margin-left: -35px;"> {{ $t('turbo.Wager') }}</span>
  <span style="margin-left: -40px;"> {{ $t('turbo.PnL / ROI') }}</span>
  
</div>
<div v-for="bet in publicBetsWithRoi" :key="bet._id" class="trade-card">
  <!-- Satır 1 -->
  <div class="trade-header">
    <!-- Trader -->
    <div class="position-badge">
      <img v-if="bet.user?.avatar"
        :src="bet.user.avatar.startsWith('http') ? bet.user.avatar : process.env.VUE_APP_BACKEND_URL + bet.user.avatar"
        class="avatar-image"
      />
    </div>
    <!-- Position -->
    <div class="position-box" :class="bet.direction.toLowerCase()">
      <img :src="coinIcon(bet.symbol)" class="coin-icon" />
      <img v-if="bet.direction === 'LONG'" src="@/assets/img/trade/up.svg" class="side-icon" />
      <img v-else src="@/assets/img/trade/down.svg" class="side-icon" />
    </div>
    <!-- Amount + Leverage -->
    <div class="amount-box">
      <div class="amount-value">{{ getFiatSymbol(bet) }}{{ formatCurrency(bet.amount) }}</div>
      <div class="leverage-value">{{ bet.leverage }}x</div>
    </div>
    <!-- PnL / ROI -->
    <div class="pnl-combined" :class="bet.pnl >= 0 ? 'win' : 'lose'">
      <div class="pnl-value">{{ getFiatSymbol(bet) }}{{ formatCurrency(bet.pnl) }}</div>
       <div class="roi-value">{{ formatPercentage(bet.roi) }}</div>
    </div>
    <!-- Info -->
    <div class="info-btn" @click="openDetails(bet)">ℹ️</div>
  </div>

  <!-- Satır 2 -->
  <div class="trade-footer">
    <div class="entry">{{ $t('turbo.Entry') }}: {{ formatPrice(bet.entryPrice, bet.symbol) }}</div>
    <div class="exit">{{ $t('turbo.Exit') }}: {{ formatPrice(bet.exitPrice, bet.symbol) }}</div>
  </div>
</div>
</div>
</div>
 <!-- ✅ Bottom Sheet (Mobil detay) -->
<div v-if="showModal && selectedBet && isMobile" class="bottom-sheet">
  <div class="bottom-sheet-header">
    <h3> {{ $t('turbo.Position Details') }}</h3>
    <button class="btn-close-modal" @click="closeModal">×</button>
  </div>

  <div class="bottom-sheet-content">
    <!-- ✅ User -->
    <div class="user-section" v-if="selectedBet.user">
      <img
        v-if="selectedBet.user?.avatar"
        :src="selectedBet.user.avatar.startsWith('http')
          ? selectedBet.user.avatar
          : process.env.VUE_APP_BACKEND_URL + selectedBet.user.avatar"
        class="avatar-large"
      />
      <span class="username">{{ selectedBet.user?.username }}</span>
    </div>

    <!-- ✅ Position -->
    <div class="position-box" :class="selectedBet.direction?.toLowerCase()">
      <img :src="coinIcon(selectedBet.symbol)" class="coin-icon" />
      <img
        v-if="selectedBet.direction === 'LONG'"
        src="@/assets/img/trade/up.svg"
        class="side-icon"
      />
      <img
        v-else
        src="@/assets/img/trade/down.svg"
        class="side-icon"
      />
      <span class="pos-text">{{ selectedBet.direction }}</span>
    </div>

    <!-- ✅ Bilgiler Grid -->
    <div class="details-grid">
      <div class="detail-box">
        <span> {{ $t('turbo.Wager') }}</span>
        <b>{{ getFiatSymbol(selectedBet) }}{{ formatCurrency(selectedBet.amount) }}</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.leverage') }}</span>
        <b>{{ selectedBet.leverage }}x</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.Entry') }}</span>
        <b>{{ formatPrice(selectedBet.entryPrice) }}</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.Exit') }}</span>
        <b>{{ formatPrice(selectedBet.exitPrice) || '-' }}</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.Liq') }}</span>
        <b>{{ formatPrice(selectedBet.liqPrice) }}</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.ROI') }}</span>
        <b :class="(selectedBet.roi || selectedBet.liveRoi) >= 0 ? 'profit' : 'loss'">
          {{ formatPercentage(selectedBet.roi || selectedBet.liveRoi) }}
        </b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.PnL') }}</span>
        <b :class="(selectedBet.pnl || selectedBet.livePnl) >= 0 ? 'profit' : 'loss'">
          {{ getFiatSymbol(selectedBet) }}{{ formatCurrency(selectedBet.pnl || selectedBet.livePnl) }}
        </b>
      </div>
    </div>
  </div>

  <!-- ✅ Footer -->
  <div class="bottom-sheet-footer">
    <button
      v-if="selectedBet.status === 'open'"
      class="btn-close"
      @click="closeBet(selectedBet)"
    >
       {{ $t('turbo.Close Position') }}
    </button>
    
  </div>
</div>

  </div>
</template>


<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'

const store = useStore()
const tabs = ['Active', 'Closed', 'Public']
const currentTab = ref('Active')
const bets = ref([])
const publicBets = ref([]) // ✅ Public bets
const showModal = ref(false)
const selectedBet = ref(null)
const isMobile = ref(window.innerWidth <= 768)
const prices = ref({})
let wsConnections = {}

const pricePrecisions = ref({})

// Fiat sembolleri
const fiatMap = {
  TRY: "₺",
  USD: "$",
  EUR: "€",
  USDT: "₮",
  CNY: "¥",
  INR: "₹",
  IDR: "Rp",
}
function getFiatSymbol(bet) {
  return fiatMap[bet.fiatCurrency] || bet.fiatCurrency
}

// Coin icon
function coinIcon(symbol) {
  const base = symbol.replace(/USDT|BUSD|USD|TRY|EUR|USDC$/i, "")
  return `https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${base.toLowerCase()}.svg`
}

// Precision loader
async function loadPrecisions() {
  try {
    const { data } = await axios.get("https://play.rivobit.com/binance/exchangeInfo")
    data.symbols.forEach(s => {
      const priceFilter = s.filters.find(f => f.filterType === "PRICE_FILTER")
      if (priceFilter) {
        const tick = priceFilter.tickSize
        const decimals = tick.includes(".")
          ? tick.split(".")[1].replace(/0+$/, "").length
          : 0
        pricePrecisions.value[s.symbol] = decimals
      }
    })
  } catch (err) {
    console.error("❌ Precision yüklenemedi:", err)
  }
}






const handleResize = () => (isMobile.value = window.innerWidth <= 768)

// Binance ticker WS
function connectWS(symbol) {
  const symLower = symbol.toLowerCase()
  const symUpper = symbol.toUpperCase()
  if (wsConnections[symUpper]) return

  const ws = new WebSocket(`wss://stream.binance.com:9443/ws/${symLower}@trade`)
  ws.onmessage = (ev) => {
    const data = JSON.parse(ev.data)
    prices.value[symUpper] = parseFloat(data.p)
  }
  ws.onerror = () => {
    setTimeout(() => connectWS(symbol), 5000)
  }

  wsConnections[symUpper] = ws
}

// Fee hesaplama
function calculateFee(pnl, feeType, feeRate) {
  if (feeType === 'Fixed') return feeRate
  return Math.abs(pnl) * (feeRate || 0.001)
}



// Live PnL/ROI
function computeLivePnl(bet) {
  const price = prices.value[bet.symbol.toUpperCase()]
  if (!price) return 0
  const entry = bet.entryPrice
  const amount = bet.amount
  const leverage = bet.leverage || 1
  let pnl = 0
  if (bet.direction === "LONG") {
    pnl = amount * ((price - entry) / entry) * leverage
  } else {
    pnl = amount * ((entry - price) / entry) * leverage
  }
  const fee = calculateFee(pnl, bet.feeType, bet.feeRate || 0.001)
  return pnl - fee
}
function computeLiveRoi(bet) {
  const pnl = computeLivePnl(bet)
  return (pnl / bet.amount) * 100
}

// Formatters
const formatCurrency = (v) => v != null ? `${Number(v).toFixed(2)}` : '-'
function formatPrice(v, symbol) {
  if (v == null) return "-"
  const sym = symbol?.toUpperCase()
  const decimals = pricePrecisions.value[sym] ?? 4
  return Number(v).toFixed(decimals)
}
const formatPercentage = (v) => v != null ? `${Number(v).toFixed(2)}%` : '-'

// Computed
const activeBets = computed(() =>
  bets.value.filter(b => b.status === 'open').map(b => ({
    ...b,
    livePnl: computeLivePnl(b),
    liveRoi: computeLiveRoi(b),
  }))
)
const publicBetsWithRoi = computed(() =>
  publicBets.value
    .map(bet => ({
      ...bet,
      roi: bet.amount ? ((bet.pnl / bet.amount) * 100).toFixed(2) : 0
    }))
    .slice(0, 10) // ✅ en fazla 10 kayıt
)


// Pagination
const closedPage = ref(1)
const pageSize = 10

const closedTotalPages = computed(() =>
  Math.ceil(closedBetsRaw.value.length / pageSize)
)

const closedBetsRaw = computed(() =>
  bets.value.filter(b => b.status === 'closed').map(b => ({
    ...b,
    roi: ((b.pnl / b.amount) * 100).toFixed(2),
  }))
)

const closedBets = computed(() => {
  const start = (closedPage.value - 1) * pageSize
  return closedBetsRaw.value.slice(start, start + pageSize)
})

// Socket
function fetchBets() {
  const socket = store.getters.socketGeneral
  socket.emit('futures:list', { token: store.getters.authToken }, (res) => {
    if (res.success) {
      bets.value = res.bets
      res.bets.forEach(b => connectWS(b.symbol))
    }
  })
}

// ✅ Public fetch
function fetchPublicBets() {
  const socket = store.getters.socketGeneral
  socket.emit('futures:public:list', (res) => {
    if (res.success) publicBets.value = res.bets
  })
}

function closeBet(bet) {
  const socket = store.getters.socketGeneral
  const price = prices.value[bet.symbol.toUpperCase()] || bet.entryPrice
  socket.emit('futures:close', { token: store.getters.authToken, betId: bet._id, closePrice: price }, (res) => {
    if (res.success) {
      fetchBets()
    } else {
      alert("Close error: " + res.error)
    }
  })
}

// Modal
function openDetails(bet) {
  selectedBet.value = bet
  showModal.value = true
}
function closeModal() {
  selectedBet.value = null
  showModal.value = false
}

// Lifecycle
onMounted(() => {
  loadPrecisions()
  fetchBets()
  fetchPublicBets()
  window.addEventListener('resize', handleResize)

  const socket = store.getters.socketGeneral
  if (socket) {
    // ✅ kendi bet listener
    socket.on('bet', (data) => {
      if (!data.bet) return
      const idx = bets.value.findIndex(b => b._id === data.bet._id)
      if (idx === -1) bets.value.unshift(data.bet)
      else bets.value[idx] = data.bet
      connectWS(data.bet.symbol)
    })
    // ✅ public bet listener
    socket.on('futures:public', (data) => {
      const bet = data.bet
      if (bet?.status === "closed") {
        publicBets.value.unshift(bet)
        if (publicBets.value.length > 50) publicBets.value.pop()
      }
    })
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  const socket = store.getters.socketGeneral
  if (socket) {
    socket.off('bet')
    socket.off('futures:public')
  }
  Object.values(wsConnections).forEach(ws => ws.close())
  wsConnections = {}
})
</script>




<style scoped>
.futures-positions {
  background: var(--background3);
  padding: 24px;
  border-radius: 7px;
  margin: 24px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 1;
  position: relative;
}

 

.tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.tab-btn {
  padding: 10px 20px;
  border-radius: 5px;
  background: var(--background2);
  color: #cccccc;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
}

.tab-btn.active {
  background: var(--buttonyellow);
  color: #000;
  box-shadow: rgb(197, 106, 24) 0px -3px 0px 0px inset, rgb(255, 234, 47) 0px 2px 0px 0px inset;
}

.table-container {
  overflow-x: auto;
}

.positions-table {
  border-collapse: separate !important; 
  border-spacing: 0 10px;   /* 10px dikey boşluk bırakır */
  width: 100%;
}

.positions-table th,
.positions-table td {
  padding: 12px 16px;
  text-align: left;
  
  font-size: 14px;
}

.positions-table th {
  
  color: #ffffff;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}

.positions-table td {
  color: #cccccc;
}

.long {
  color: #4caf50;
}
.short {
  color: #f44336;
}
.profit {
  color: #4caf50;
}
.loss {
  color: #f44336;
}

.actions {
  display: flex;
  gap: 8px;
}

.btn-close,
.btn-detail,
.btn-close-modal {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-close {
 background: var(--buttonyellow);
    box-shadow: var(--buttonyellowbox);
    text-shadow: -1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), -1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18);
    border-radius: 8px;
    color: #fff;
    font-weight: bold;
}
 

.btn-detail {
  background: #3a3a3a;
  color: #ffffff;
}
 

.btn-close-modal {
  background: var(--background2);
  color: #ffffff;
}
 

/* ✅ User info (Public tab) */
.user-cell {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.avatar-image {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.username {
  color: #ffffff;
  font-weight: 500;
}

.vip-badge-small {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

/* ✅ Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #1e1e1e;
  padding: 24px;
  border-radius: 12px;
  width: 600px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.modal-header h3 {
  margin: 0;
  color: #ffffff;
}

.modal-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}
.modal-section {
  display: contents;
}

.modal-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: #2a2a2a;
  border-radius: 8px;
}
.modal-field span {
  font-size: 12px;
  color: #aaaaaa;
}
.modal-field b {
  color: #ffffff;
  font-weight: 500;
}

.modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

/* ✅ Mobile Bottom Sheet */
.bottom-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--background);
  border-radius: 16px 16px 0 0;
  padding: 24px;
  max-height: 80vh;
  overflow-y: auto;
  z-index: 1000;
  padding-bottom: 100px;
}

.bottom-sheet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.bottom-sheet-header h3 {
  margin: 0;
  color: #ffffff;
}

.bottom-sheet-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (max-width: 768px) {
  .futures-positions {
    padding: 16px;
  }

  .positions-table th,
  .positions-table td {
    padding: 8px;
    font-size: 12px;
  }

  .btn-close,
  .btn-detail,
  .btn-close-modal {
    padding: 6px 12px;
  }

  .avatar-image {
    width: 24px;
    height: 24px;
  }

  .vip-badge-small {
    width: 16px;
    height: 16px;
  }
}

.coin-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}

.side-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.side-badge.long {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.side-badge.short {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

.side-icon {
  width: 18px;
  height: 18px;
}
.pnl-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  min-width: 60px;
  text-align: center;
}

.pnl-badge.win {
  background: rgba(76, 175, 80, 0.15);
  color: #4caf50;
}

.pnl-badge.lose {
  background: rgba(244, 67, 54, 0.15);
  color: #f44336;
}
.pnl-combined {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 6px;   /* daha dar padding */
  border-radius: 6px;
  width: auto;        /* sabit genişlik yok */
}

.pnl-combined.win {
  background: rgba(76, 175, 80, 0.15);
  color: #4caf50;
}

.pnl-combined.lose {
  background: rgba(244, 67, 54, 0.15);
  color: #f44336;
}

.pnl-value {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

.roi-value {
  font-size: 11px;
  opacity: 0.85;
  line-height: 1.2;
}

/* ✅ Desktop / Mobile ayırımı */
.desktop-only {
  display: table;
}
.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block;
  }

  /* Mobil başlık (tablo header gibi hizalı) */
  .mobile-header {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0px, 1fr));
    gap: 8px;
    padding: 8px 12px;
    background: var(--background2);
    border-radius: 6px;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 13px;
    color: #fff;
  }

  /* Mobil kart */
  .trade-card {
    background: var(--background2);
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  }

  .trade-header {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
    align-items: center;
    gap: 6px;
  }

  .position-badge {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .info-btn {
    cursor: pointer;
    font-size: 16px;
    text-align: center;
  }
}

/* ✅ Bottom Sheet içerik düzeni */
.bottom-sheet-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
.detail-box span {
  font-size: 13px;
  color: #aaa;
}
.detail-box b {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}
/* ✅ Position kutusu (coin + yön) */
.position-box {
  display: inline-flex;
  align-items: center;
  gap: 4px;              /* ikon + yazı arası daha küçük */
  padding: 4px 6px;      /* iç boşluğu küçülttük */
  border-radius: 6px;
  width: fit-content;    /* içeriğe göre genişlik */
  min-width: unset;      /* olası default min genişlik iptal */
  height: 100%;
}


.position-box.long {
  background:var(--background1); /* yeşil transparan */
  color: #22c55e;
}

.position-box.short {
  background: var(--background1); /* kırmızı transparan */
  color: #ef4444;
}

/* ✅ Amount + Leverage kutusu */
.amount-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.amount-value {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.2;
}

.leverage-value {
  font-size: 12px;
  font-weight: 500;
  color: #aaaaaa;
  line-height: 1.2;
}

/* Mobilde kutuları biraz küçültelim */
@media (max-width: 768px) {
  .position-box {
    padding: 4px 8px;
  }
  .amount-value {
    font-size: 13px;
  }
  .leverage-value {
    font-size: 11px;
  }
}
/* ✅ Mobil kart düzeni */
.trade-card {
  background: var(--background2);
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
}

.trade-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

/* ✅ Alt satır (Entry / Liq / Exit) */
.trade-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid rgba(255,255,255,0.1);
  font-size: 12px;
  color: #aaa;
}

.trade-footer div {
  flex: 1;
  text-align: center;
}

/* ✅ Position kutusu */
.position-box {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}
.position-box.long {
  background: rgba(34,197,94,0.15);
  color: #22c55e;
}
.position-box.short {
  background: rgba(239,68,68,0.15);
  color: #ef4444;
}

/* ✅ Amount box (üst büyük, alt küçük) */
.amount-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}
.amount-value {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}
.leverage-value {
  font-size: 11px;
  color: #aaa;
}

/* ✅ PnL kutusu */
.pnl-combined {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 6px;
  border-radius: 6px;
}
.pnl-combined.win {
  background: rgba(34,197,94,0.15);
  color: #22c55e;
}
.pnl-combined.lose {
  background: rgba(239,68,68,0.15);
  color: #ef4444;
}
.pnl-value {
  font-size: 13px;
  font-weight: 600;
}
.roi-value {
  font-size: 11px;
  opacity: 0.85;
}

/* ✅ Info butonu */
.info-btn {
  cursor: pointer;
  font-size: 14px;
  padding: 4px 6px;
  border-radius: 10px;
 background: rgb(44, 40, 82);
    color: rgb(217, 209, 244);
    box-shadow: rgb(35, 32, 66) 0px -3px 0px 0px inset, rgb(89, 81, 142) 0px 2px 0px 0px inset;
    text-shadow: rgb(25, 25, 57) 0px 1px 0px;
    color: #fff;
    border: 3px solid var(--roo-btn-outline-color, #090C1D);
}
 

/* ✅ Bottom sheet içerik düzeni */
.bottom-sheet-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.avatar-large {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.username {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

.position-box {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 600;
  width: fit-content;
}
.position-box.long {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}
.position-box.short {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.detail-box {
  background: var(--background2);
  padding: 10px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.detail-box span {
  font-size: 12px;
  color: #aaa;
}
.detail-box b {
  font-size: 14px;
  color: #fff;
}
/* ✅ Desktop tablo satır kutusu */
.trade-row {
  background: var(--background2);   /* satır arka plan */
  border-radius: 6px;
  overflow: hidden;
  transition: background 0.25s ease, transform 0.2s ease;
}

/* satırlar arası boşluk için */
.trade-row td {
  background: transparent;          /* td kendi bg almasın */
  padding: 14px 16px;
}

 

/* ilk ve son hücreye ekstra padding */
.trade-row td:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.trade-row td:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

/* tablonun default borderını kapat */
.positions-table td {
  border-bottom: none;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.pagination button {
  background: var(--background2);
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

 

.pagination.desktop-only {
  display: block;
}
.pagination.span {
  font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
}
@media (max-width: 768px) {
  .pagination.desktop-only {
    display: none !important;
  }
}

</style>